import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Mortgage = function Mortgage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M51.77 27.159L29.33 5.494a1.846 1.846 0 00-2.569 0L10.866 20.776V8.618a.348.348 0 01.349-.347H16.6a.349.349 0 01.349.347v1.891a.75.75 0 001.5 0V8.618A1.851 1.851 0 0016.6 6.771h-5.385a1.85 1.85 0 00-1.849 1.847v13.6l-5.137 4.94a.75.75 0 101.04 1.081L27.8 6.572a.349.349 0 01.487 0l22.44 21.665a.75.75 0 001.042-1.079z M11.234 51.025a1.849 1.849 0 01-1.85-1.846V28.965a1.848 1.848 0 01.581-1.344l16.792-16.288a1.855 1.855 0 012.546-.006l16.74 16.3a1.846 1.846 0 01.57 1.333l-.03 20.174a1.849 1.849 0 01-1.849 1.845zm16.8-38.7a.35.35 0 00-.243.1L11 28.705a.353.353 0 00-.117.26v20.214a.347.347 0 00.349.346l33.5-.041a.348.348 0 00.35-.347l.03-20.175a.346.346 0 00-.108-.25l-16.74-16.3a.335.335 0 00-.228-.09zm17.829 16.638z M32.132 36.889a3.554 3.554 0 00-3.261-3.262L28.852 30a2.764 2.764 0 011.079.493 1.6 1.6 0 01.673 1.236.75.75 0 101.5-.007 3.068 3.068 0 00-1.245-2.407 4.283 4.283 0 00-2.016-.851l-.007-1.246a.75.75 0 10-1.5.009l.007 1.246a4.29 4.29 0 00-2.007.872 2.979 2.979 0 00.026 4.826 4.3 4.3 0 002.016.85l.02 3.625c-1-.238-1.749-.906-1.753-1.722a.75.75 0 10-1.5.008 3.562 3.562 0 003.261 3.251l.007 1.319a.751.751 0 00.75.746.75.75 0 00.746-.755l-.007-1.316a3.562 3.562 0 003.23-3.288zm-5.841-3.9a1.486 1.486 0 01-.014-2.48 2.71 2.71 0 011.075-.5l.018 3.475a2.734 2.734 0 01-1.079-.491zm2.609 5.657l-.019-3.471a2.031 2.031 0 011.751 1.725 2 2 0 01-1.732 1.746z"
  }));
};

Mortgage.displayName = 'Mortgage';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Mortgage.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Mortgage;